import React from "react";
import { RichText } from "prismic-reactjs";

const Eyebrow = ({ text }) => (
	<RichText render={text} />
);

export default Eyebrow;